import { createAsyncThunk, createAction } from '@reduxjs/toolkit'
import planningRecordService from '../../../services/planningRecordService'
import { PlanningRecord } from '@leadgen/models/client'

class PlanningRecordActions {
  loadPlanningRecord = createAsyncThunk(
    'planningRecord/loadPlanningRecord',
    async (
      {
        planningRecordId,
      }: {
        planningRecordId: string
      },
      { dispatch },
    ) => {
      const response = await planningRecordService.subscribeToPlanningRecord({
        planningRecordId,
        onPlanningRecordUpdated: planningRecord => {
          dispatch(this.updatePlanningRecord(planningRecord))
        },
      })
      return response
    },
  )
  updatePlanningRecord = createAction(
    'planningRecord/updatePlanningRecord',
    (planningRecord: PlanningRecord) => ({
      payload: planningRecord,
    }),
  )
}

export default new PlanningRecordActions()
